export const AIRLINE_SECTION_TYPE_ID = 'airline-section';
export const EXTERNAL_LINK_TYPE_ID = 'external-link';
export const INTERNAL_LINK_TYPE_ID = 'internal-link';
export const TEXT_SECTION_TYPE_ID = 'text-section';
export const ACCORDION_ITEM_TYPE_ID = 'accordion-item';
export const ACCORDION_SECTION_TYPE_ID = 'accordion-section';
export const GENERIC_CONTENT_PAGE_TYPE_ID = 'page';
export const CARD_SECTION_TYPE_ID = 'card-section';
export const FEATURE_ENTRYPOINT_TYPE_ID = 'featureEntrypointSection';
export const IMAGE_SECTION_TYPE_ID = 'imageSection';
export const CARD_ITEM_TYPE_ID = 'card-item';
export const CONTACT_ITEM_TYPE_ID = 'contact-item';
export const CONTACT_SECTION_TYPE_ID = 'contact-section';
export const QUICK_LINKS_SECTION_TYPE_ID = 'quick-links-section';
export const CALL_TO_ACTION_SECTION_TYPE_ID = 'call-to-action-section';
export const EMAIL_LINK_TYPE_ID = 'email-link';
export const PHONE_LINK_TYPE_ID = 'phone-link';
export const ASSET_LINK_TYPE_ID = 'asset-link';
export const HIGHLIGHT_SECTION_TYPE_ID = 'highlight-section';
export const NEWS_ALERT_TYPE_ID = 'news-alert';
export const FOOTER_TYPE_ID = 'footer';
export const AIRLINE_TYPE_ID = 'airline';
export const AIRPORT_TYPE_ID = 'airport';
export const IFRAME_SECTION_TYPE_ID = 'iframe';
export const MENU_ITEM_TYPE_ID = 'menu-item';
export const SUBMENU_ITEM_TYPE_ID = 'submenu-item';
export const SITE_SECTION_ID = 'site-section';
export const CUSTOM_PAGES_CONTAINER_TYPE_ID = 'custom-pages';
export const NEWS_ITEM_TYPE_ID = 'newsArticle';
export const NEWS_SECTION_TYPE_ID = 'news-section';
export const BLOG_ITEM_TYPE_ID = 'blog';
export const BLOG_SECTION_TYPE_ID = 'blogSection';
export const CONTENT_CATEGORY_TYPE_ID = 'contentCategory';
export const SOLICITATION_TYPE_ID = 'solicitation';
export const GALLERY_TYPE_ID = 'gallery';
export const COLUMN_SECTION_TYPE_ID = 'columnSection';
export const PRESS_RELEASE_TYPE_ID = 'pressRelease';
export const NEWSLETTER_TYPE_ID = 'newsletter';
export const CAROUSEL_SECTION_TYPE_ID = 'carouselSection';
